import { render, staticRenderFns } from "./StampHistory.vue?vue&type=template&id=5d088c85&scoped=true"
import script from "./StampHistory.vue?vue&type=script&lang=js"
export * from "./StampHistory.vue?vue&type=script&lang=js"
import style0 from "./StampHistory.vue?vue&type=style&index=0&id=5d088c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d088c85",
  null
  
)

export default component.exports